"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var capitalize_1 = __importDefault(require("./capitalize"));
/**
* Convert current string to camel case
* i.e hello-world will become: helloWorld
*
* @param string separator default is by dash(-) or underscore(_)
* @return string
* @see String.capitalize
*/
function toStudlyCase(string, separator) {
    if (separator === void 0) { separator = '-|_|\\s'; }
    var regex = new RegExp(separator, 'g');
    return string.split(regex).map(function (word) { return capitalize_1.default(word); }).join('');
}
exports.default = toStudlyCase;
//# sourceMappingURL=toStudlyCase.js.map